
import React, { useMemo, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { convertLocalDate } from "../../../../Utils/configController";
import LogsDataTable from "./LogsDataTable";
import { Button, Col, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import { useEffect, useRef } from "react";
import { jsPlumb } from "jsplumb";
import AutomationFormOffcanvas from "./AutomationModal";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";
import { toast } from "react-toastify";
import request from "../../../../helpers/request";
export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

const AutomationList = ({ userId, selectedPremise }: ChipsControlProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isAutomationModalOpen, setIsAutomationModalOpen] = useState(false);
  const [selectedAutomationList, setSelectedAutomationList] =
    useState<any>(null);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [editAutomation, setEditAutomation] = useState<any>(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState<any>(null);
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSaved = () => {
    setRefreshKey((k) => k + 1);
  };
  const columns = [
    {
      name: "Name",
      selector: (row: any) => row?.name || "-",
      cell: (row: any) => <div>{row?.name || "-"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Any Situation",
      selector: (row: any) => (row?.isAnySituation ? "True" : "False"),
      cell: (row: any) => <div>{row?.isAnySituation ? "True" : "False"}</div>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row?.status ? "True" : "False"),
      cell: (row: any) => <div>{row?.status ? "True" : "False"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Last Execute Date",
      selector: (row: any) => row?.lastExeculateDateTime || "",
      cell: (row: any) => (
        <div>
          {row?.lastExeculateDateTime
            ? convertLocalDate(row.lastExeculateDateTime)
            : "-"}
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Effective Start",
      selector: (row: any) => row?.effectiveTimePeriodStart || "",
      cell: (row: any) => <div>{row?.effectiveTimePeriodStart || "-"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Effective End",
      selector: (row: any) => row?.effectiveTimePeriodEnd || "",
      cell: (row: any) => <div>{row?.effectiveTimePeriodEnd || "-"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Is Active",
      selector: (row: any) => (row?.isActive ? "Yes" : "No"),
      cell: (row: any) => <div>{row?.isActive ? "Yes" : "No"}</div>,
      sortable: true,
      wrap: true,
    },

    {
      name: "Next Active Effective",
      selector: (row: any) => row?.nextActiveEffectiveDateTime || "",
      cell: (row: any) => (
        <div>
          {row?.nextActiveEffectiveDateTime
            ? convertLocalDate(row.nextActiveEffectiveDateTime)
            : "-"}
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Notification Subscribed",
      selector: (row: any) => (row?.isNotificationSubscribed ? "Yes" : "No"),
      cell: (row: any) => (
        <div>{row?.isNotificationSubscribed ? "Yes" : "No"}</div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Details",
      cell: (row: any) => {
        return (
          <div className="d-flex align-items-center justify-content-center ">
            <button
              className="btn btn-sm"
              onClick={() => {
                setSelectedAutomationList(row || {});
                setIsAutomationModalOpen(true);
              }}
            >
              <i className="bx bx-info-circle fs-4"></i>
            </button>
            {/* edit automation */}
            {/* <button
              className="btn btn-sm"
              onClick={() => {
                setEditAutomation(row);
                setShowForm(true);
              }}
            >
              <i className="bx bx-pencil fs-4"></i>
            </button>
            <button
              className="btn btn-sm"
              onClick={() => {
                setDeleteTarget(row);
                setDeleteModalOpen(true);
              }}
            >
              <i className="bx bx-trash fs-4 text-danger "></i>
            </button> */}
          </div>
        );
      },
      sortable: false,
      wrap: true,
    },
  ];
  const confirmDelete = async () => {
    const automationId = deleteTarget?._id;

    if (!automationId) {
      toast.error("Unable to find automation to delete");
      return;
    }

    setDeletingId(automationId);
    try {
      await request.delete(`${url.BASE_URL}${url.DELETE_AUTOMATION}`, {
        automationId,
      });
      toast.success("Automation deleted successfully");
      setDeleteModalOpen(false);
      setDeleteTarget(null);
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Failed to delete automation", error);
      toast.error("Failed to delete automation");
    } finally {
      setDeletingId(null);
    }
  };
  return (
    <div>
      <LogsDataTable
        key={refreshKey}
        apiURL={`${url.BASE_URL}${url.GET_AUTOMATION_LIST}`}
        title="Automation List"
        columns={columns}
        loading={loading}
        setLoading={setLoading}
        userId={userId}
        selectedPremise={selectedPremise}
        actionButton={
          <Button
            color="dark"
            size="sm"
            className="d-flex align-items-center gap-1 p-1 fw-bold rounded-3"
            onClick={() => {
              setEditAutomation(null); 
              setShowForm(true);
            }}
            disabled
          >
            <i className="bx bx-plus" style={{ fontSize: 16 }} />
            Create Automation
          </Button>
        }
      />
      <SharedUsersModal
        isAutomationModalOpen={isAutomationModalOpen}
        selectedAutomationList={selectedAutomationList}
        onClose={() => {
          setIsAutomationModalOpen(false);
          setSelectedAutomationList(null);
        }}
      />
      <AutomationFormOffcanvas
        isOpen={showForm}
        onClose={() => {
          setShowForm(false);
          setEditAutomation(null);
        }}
        userId={userId}
        selectedPremise={selectedPremise}
        onSaved={handleSaved}
        editData={editAutomation}
      />
      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Automation?"
          text={`Are you sure you want to delete the automation "${
            deleteTarget?.name || "this automation"
          }"? This cannot be undone.`}
          buttonText="Delete"
          onClick={confirmDelete}
          cancleBtnClick={() => {
            setDeleteModalOpen(false);
            setDeleteTarget(null);
          }}
          loading={
            deletingId === (deleteTarget?.automationId || deleteTarget?._id)
          }
        />
      )}
    </div>
  );
};

export default AutomationList;

function SharedUsersModal({
  isAutomationModalOpen,
  selectedAutomationList,
  onClose,
}: any) {
  return (
    <Modal
      isOpen={isAutomationModalOpen}
      className="modal-xl"
      style={{
        backgroundColor: "#F7F7FA",
        borderRadius: "12px",
        padding: "0px",
      }}
      role="dialog"
      autoFocus={true}
      toggle={onClose}
    >
      <div className="modal-header justify-content-between">
        <h5 className="modal-title">Automation</h5>
        <button
          className="btn p-0"
          style={{ border: "none" }}
          onClick={onClose}
        >
          <box-icon name="x" size="30px"></box-icon>
        </button>
      </div>

      <ModalBody style={{ padding: "12px", backgroundColor: "#F7F7FA" }}>
        <Row>
          <AutomationFlow automation={selectedAutomationList} />
        </Row>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-outline-secondary" onClick={onClose}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
}

function AutomationFlow({ automation }: { automation?: any }) {
  const conditions = automation?.condition || [];
  const actions = automation?.action || [];
  const isAny = automation?.isAnySituation;
  const containerRef = useRef<any>(null);

  const gap = 40;

  useEffect(() => {
    if (!containerRef.current) return;

    const instance = jsPlumb.getInstance({
      Connector: ["Bezier", { curviness: 90 }],
      Anchors: ["RightMiddle", "LeftMiddle"],
      PaintStyle: { stroke: "#555", strokeWidth: 3 },
      Endpoint: "Blank",
      Container: containerRef.current,
    });

    instance.setContainer(containerRef.current);

    // connect each condition to merge node
    if (isAny) {
      conditions.forEach((c: any, i: any) => {
        instance.connect({
          source: `cond-${i}`,
          target: "action-panel",
          overlays: [["Arrow", { location: 1, width: 15, length: 15 }]],
        });
      });
    } else {
      instance.connect({
        source: `condition-panel`,
        target: "action-panel",
        overlays: [["Arrow", { location: 1, width: 15, length: 15 }]],
      });
    }
    return () => instance.reset();
  }, [conditions, actions, isAny]);

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: 20,
      }}
    >
      <div
        ref={containerRef}
        style={{
          // width: "100%",
          width: "1100px",
          padding: 40,
          display: "flex",
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* LEFT CONDITIONS */}
        <div
          id="condition-panel"
          style={
            isAny
              ? { marginRight: 150, position: "relative" }
              : {
                  background: "#fff",
                  border: "2px solid #777",
                  borderRadius: 14,
                  width: 340,
                  padding: 25,
                  marginRight: 150,
                  position: "relative",
                }
          }
        >
          <p
            style={{
              position: "absolute",
              top: -40,
              left: "50%",
              transform: "translateX(-50%)",
              background: "black",
              color: "white",
              padding: "2px 8px",
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Conditions
          </p>

          {conditions?.map((c: any, i: number) => (
            <div
              key={i}
              id={`cond-${i}`}
              style={{
                width: 286,
                background: "#fff",
                border: "2px solid #aaa",
                borderRadius: 12,
                padding: 12,
                marginBottom: gap,
                fontFamily: "sans-serif",
              }}
            >
              {/* TITLE */}
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                {c.label || "(no label)"}
              </div>

              {Object.entries(c).map(([key, value]) => {
                if (
                  key === "label" ||
                  key === "_id" ||
                  key === "chipId" ||
                  key === "chipSwitchId" ||
                  key === "id"
                )
                  return null;
                if (!value) return null;

                return (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>{key}</span>
                    <span style={{ color: "#444" }}>
                      {String(value || "-")}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        {/* ACTION PANEL */}
        <div
          id="action-panel"
          style={{
            background: "#fff",
            border: "2px solid #777",
            borderRadius: 14,
            width: 340,
            padding: 25,
            marginLeft: 180,
            position: "relative",
          }}
        >
          <p
            style={{
              position: "absolute",
              top: -40,
              left: "50%",
              transform: "translateX(-50%)",
              background: "black",
              color: "white",
              padding: "2px 8px",
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Actions
          </p>
          {actions.map((a: any, i: any) => (
            <div
              key={i}
              style={{
                background: "#fff",
                border: "2px solid #aaa",
                borderRadius: 12,
                width: 286,
                padding: "12px 16px",
                marginBottom: 20,
                fontWeight: 600,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 15,
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                {a?.label || "(no label)"}
              </div>

              {/* KEY VALUE PAIRS */}
              {Object.entries(a).map(([key, value]) => {
                if (
                  key === "label" ||
                  key === "_id" ||
                  key === "chipId" ||
                  key === "chipSwitchId" ||
                  key === "id"
                )
                  return null;
                if (!value) return null;
                return (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>{key}:</span>
                    <span style={{ color: "#444" }}>
                      {String(value || "-")}
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


// const ink = "#1C1F26";
// const paper = "#FBFAF7";
// const line = "#E1DCCF";
// const amber = "#C97A2E"; // conditions
// const indigo = "#4A47D8"; // actions
// const muted = "#8A8578";
// function AutomationFlow({ automation }: { automation?: any }) {
//   const conditions = automation?.condition || [];
//   const actions = automation?.action || [];
//   const isAny = automation?.isAnySituation;
//   const containerRef = useRef<any>(null);

//   const gap = 32;

//   useEffect(() => {
//     if (!containerRef.current) return;

//     const instance = jsPlumb.getInstance({
//       Connector: ["Bezier", { curviness: 60 }],
//       Anchors: ["RightMiddle", "LeftMiddle"],
//       PaintStyle: { stroke: indigo, strokeWidth: 2 },
//       Endpoint: "Blank",
//       Container: containerRef.current,
//     });

//     instance.setContainer(containerRef.current);

//     if (isAny) {
//       conditions.forEach((c: any, i: any) => {
//         instance.connect({
//           source: `cond-${i}`,
//           target: "action-panel",
//           overlays: [["Arrow", { location: 1, width: 10, length: 10 }]],
//         });
//       });
//     } else {
//       instance.connect({
//         source: `condition-panel`,
//         target: "action-panel",
//         overlays: [["Arrow", { location: 1, width: 10, length: 10 }]],
//       });
//     }
//     return () => instance.reset();
//   }, [conditions, actions, isAny]);

//   // shared card style for a single condition/action row
//   const rowCard = (accent: string, isLast: boolean): React.CSSProperties => ({
//     background: "#fff",
//     border: `1px solid ${line}`,
//     borderLeft: `3px solid ${accent}`,
//     borderRadius: 8,
//     padding: "12px 14px",
//     marginBottom: isLast ? 0 : gap,
//     fontFamily:
//       "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
//     minWidth: 260,
//     maxWidth: 260,
//   });

//   const kvRow = (key: string, value: any) => (
//     <div
//       key={key}
//       style={{
//         display: "flex",
//         justifyContent: "space-between",
//         gap: 10,
//         marginTop: 6,
//         fontSize: 12.5,
//         lineHeight: 1.4,
//       }}
//     >
//       <span style={{ color: muted, fontWeight: 500, whiteSpace: "nowrap" }}>
//         {key}
//       </span>
//       <span style={{ color: ink, fontWeight: 600, textAlign: "right" }}>
//         {String(value || "-")}
//       </span>
//     </div>
//   );

//   const filterEntries = (obj: any) =>
//     Object.entries(obj).filter(
//       ([key, value]) =>
//         !["label", "_id", "chipId", "chipSwitchId", "id"].includes(key) &&
//         !!value
//     );

//   return (
//     // OUTER: scrolls both directions, nothing gets clipped
//     <div
//       style={{
//         width: "100%",
//         maxHeight: "78vh",
//         overflow: "auto",
//         background: paper,
//         borderRadius: 16,
//       }}
//     >
//       <div
//         ref={containerRef}
//         style={{
//           minWidth: "fit-content",
//           width: "max-content",
//           padding: "56px 48px 40px",
//           display: "flex",
//           position: "relative",
//           alignItems: "flex-start",
//           justifyContent:"center",
//           gap: 96,
//         }}
//       >
//         {/* CONDITIONS COLUMN */}
//         <div
//           id="condition-panel"
//           style={{ position: "relative", paddingTop: 4 }}
//         >
//           <ColumnLabel text={isAny ? "IF · ANY MATCH" : "IF · ALL MATCH"} accent={amber} />

//           {conditions.length === 0 && <EmptyNote text="No conditions set" />}

//           {conditions.map((c: any, i: number) => (
//             <div key={i} id={`cond-${i}`} style={rowCard(amber, i === conditions.length - 1)}>
//               <RowHeader index={i + 1} label={c.label || "(no label)"} accent={amber} />
//               {filterEntries(c).map(([key, value]) => kvRow(key, value))}
//             </div>
//           ))}
//         </div>

//         {/* ACTIONS COLUMN */}
//         <div id="action-panel" style={{ position: "relative", paddingTop: 4 }}>
//           <ColumnLabel text="THEN · RUN" accent={indigo} />
//           <div className="border border-2 border-secondary p-4 rounded-3">

//           {actions.length === 0 && <EmptyNote text="No actions set" />}

//           {actions.map((a: any, i: number) => (
//             <div key={i} style={rowCard(indigo, i === actions.length - 1)}  >
//               <RowHeader index={i + 1} label={a?.label || "(no label)"} accent={indigo} />
//               {filterEntries(a).map(([key, value]) => kvRow(key, value))}
//             </div>
//           ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ColumnLabel({ text, accent }: { text: string; accent: string }) {
//   return (
//     <div
//       style={{
//         display: "inline-flex",
//         alignItems: "center",
//         gap: 6,
//         marginBottom: 20,
//         fontFamily: "'Inter', sans-serif",
//         fontSize: 11,
//         fontWeight: 700,
//         letterSpacing: "0.08em",
//         color: accent,
//         background: `${accent}14`,
//         border: `1px solid ${accent}33`,
//         borderRadius: 999,
//         padding: "4px 10px",
//       }}
//     >
//       {text}
//     </div>
//   );
// }

// function RowHeader({
//   index,
//   label,
//   accent,
// }: {
//   index: number;
//   label: string;
//   accent: string;
// }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//       <span
//         style={{
//           fontSize: 10.5,
//           fontWeight: 700,
//           color: "#fff",
//           background: accent,
//           borderRadius: 5,
//           padding: "1px 6px",
//         }}
//       >
//         {String(index).padStart(2, "0")}
//       </span>
//       <span style={{ fontWeight: 700, fontSize: 13.5, color: ink }}>
//         {label}
//       </span>
//     </div>
//   );
// }

// function EmptyNote({ text }: { text: string }) {
//   return (
//     <div
//       style={{
//         fontFamily: "'Inter', sans-serif",
//         fontSize: 12.5,
//         color: muted,
//         fontStyle: "italic",
//       }}
//     >
//       {text}
//     </div>
//   );
// }